import { Banksy } from "banksy-sdk";

const banksy = new Banksy(
  // "ck_test_782e77b0-0529-4ef5-bfbd-bf86d41dbe43"
  "ck_test_cf9e043f-c1e1-43cf-94c8-b7f2f3a316fb",
  "sandbox"
);

export default banksy;
